import Vue from 'vue';

export default {

      async fetchDListExternals({ commit }) {
        return Vue.axios.get(Vue.$url("distribution-list-ext"))
          .then((rsp) => commit("SET_DLISTEXTERNAL", rsp.data))
          
      },

      async fetchDListExternalsByDprId({ commit }, dprId) {
        return Vue.axios.get(Vue.$url("distribution-list-ext/"+ dprId + "/available"))
          .then((rsp) => commit("SET_DLISTEXTERNAL", rsp.data))
          
      },
 
}